import React from 'react';
import DocumentModuleV2 from './DocumentModuleV2';

export default function PurchaseOrdersV2() {
  return (
    <DocumentModuleV2
      kind="purchase-orders"
      title="Purchase Orders"
      counterpartyLabel="Supplier"
    />
  );
}
